<!-- <h6 class="loginHeadingText text-start pt-4">PRODUCT INFORMATION </h6> -->     
<div class="d-flex align-items-center pt-4 pb-3"> 
    <h6 class="loginHeadingText text-start mb-0">PRODUCT INFORMATION</h6>
    <span *ngIf="refType == 'Project'" class="ms-2" style="font-weight: bold;font-size: medium;">(If relevant to the project)</span>&nbsp;
    <a (click)="showReminderDialog()">
        <img src="assets/images/mail_icon.png" alt="email" class="emailicon" title="Send Reminder Email">
    </a>
</div>
<div class="row">
    <div class="col-md-9">
        <div class="d-flex">
            <div class="me-2">
                <input type="radio" name="radiolist"  [checked]="isRadioChecked" (change)="handleRadioChange($event)" />
            </div>
            <div>
                <p class="text-blue">
                    Download the most updated product list and upload the ones required</p>
            </div>
        </div>
    </div>
    <div class="col-md-3 text-end">
        <a href="#" (click)="downloadExcel($event)">
            <img src="assets/images/download_kkk.png" class="w-27px" alt="">
        </a>
    </div>
</div>

<div class="suneel">
    <div class="mb-3 mt-3">
        <label for="" class="mb-1">UPLOAD PRODUCT LIST</label>
        <div class="input-group custom-file-button">

            <input type="file" class="form-control"  #productFileInput id="productFileInput" accept=".xls,.xlsx" (change)="onFileSelected($event)"
                [disabled]="disableProductsSection">
            <label class="input-group-text" for="productFileInput">UPLOAD</label>
        </div>
    </div>

    <div class="row">
        <div class="col-md-1 pe-0">
            <img src="assets/images/close_mark.svg" alt="" (click)="onDelete()" *ngIf="isFileUploaded">
        </div>
        <div class="col-md-8 ps-0">
            <a href="#" class="fw-bold ms-2" style="color:#0c9ef1; text-decoration: none;" (click)="downLoadExcelPreview($event)">
                {{fileName}}</a>
        </div>
        <div class="col-md-3 text-end">
            <p class="mb-0">{{displayTotalCount}}</p>
        </div>
    </div>

    <!-- <div class="row mt-4">
        <div class="col-md-12 ps-2">
            <div class="form-check activityType">
                <input class="form-check-input" type="checkbox" [checked]="isProductReviewChecked" id="flexCheckDefault" (change)="handleReviewConfirmChange($event)"
                />
                <label class="form-check-label" for="flexCheckDefault">
                    Review Item information and confirm it is accurate
                </label>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="isProductReviewedBy != '' && isProductReviewedBy != null">
        <span class="d-inline">Reviewed By: {{isProductReviewedBy}} & Reviewed On: {{isProductReviewedDate | date:'dd-MMM-yyyy'}}</span>&nbsp;
    </div> -->
</div>